/** Aussteller-Profil je Coach für E-Rechnung (Firestore: coach_invoice_profiles/{coachId}). */
export interface CoachEInvoiceProfile {
  displayName: string;
  accountHolder: string;
  bankName: string;
  iban: string;
  bic: string;
  taxNumber: string;
  vatId: string;
  street: string;
  zip: string;
  city: string;
  country: string;
  email: string;
  phone: string;
  reverseCharge: boolean;
  defaultPaymentTermsDays: number;
}

/** Leer — Coaches tragen selbst ein; keine Festwerte im Code. */
export const EMPTY_COACH_EINVOICE_PROFILE: CoachEInvoiceProfile = {
  displayName: '',
  accountHolder: '',
  bankName: '',
  iban: '',
  bic: '',
  taxNumber: '',
  vatId: '',
  street: '',
  zip: '',
  city: '',
  country: 'DE',
  email: '',
  phone: '',
  reverseCharge: false,
  defaultPaymentTermsDays: 14,
};

/** Fester Empfänger Finanztresor (Coach → PreisExpert). */
export const PREISEXPERT_EINVOICE_BUYER = {
  companyName: 'PreisExpert',
  contactPerson: 'Christian Funk',
  email: 'erfolg@friseur-coaching.de',
  street: 'Rotehahnstraße 2',
  zip: '21335',
  city: 'Lüneburg',
  country: 'DE',
  vatId: 'DE235671457',
} as const;

/**
 * Starter-Werte für Owner (Christian), wenn noch kein Profil gespeichert ist.
 * Nur Formular-Hilfe — wird erst nach Speichern für ZUGFeRD genutzt.
 */
export const PREISEXPERT_OWNER_EINVOICE_DEFAULTS: CoachEInvoiceProfile = {
  displayName: 'PreisExpert',
  accountHolder: 'Christian Funk',
  bankName: '',
  iban: 'DE43 2406 0300 8523 1266 00',
  bic: 'GENODEF1NBU',
  taxNumber: '',
  vatId: 'DE235671457',
  street: 'Rotehahnstraße 2',
  zip: '21335',
  city: 'Lüneburg',
  country: 'DE',
  email: 'erfolg@friseur-coaching.de',
  phone: '',
  reverseCharge: false,
  defaultPaymentTermsDays: 14,
};
